import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    mapType: "satellite",
    panelOptions: localStorage.getItem('panelOptions')
        ? JSON.parse(localStorage.getItem('panelOptions'))
        : [],
    selectedDisplayOption: 'plateNumber',
    mapButton: false,
    rightButton: false
};

const mapSettingsSlice = createSlice({
    name: 'mapSettings',
    initialState,
    reducers: {
        setMapType: (state, action) => {
            state.mapType = action.payload;
        },
        setPanelOptions: (state, action) => {
            state.panelOptions = action.payload;
            localStorage.setItem('panelOptions', JSON.stringify(action.payload));
        },
        setSelectedDisplayOption: (state, action) => {
            state.selectedDisplayOption = action.payload;
        },
        toggleMapButton: (state) => {
            state.mapButton = !state.mapButton;
        },
        toggleRightButton: (state) => {
            state.rightButton = !state.rightButton;
        },
    },
});

export const {
    setMapType,
    setPanelOptions,
    setSelectedDisplayOption,
    toggleMapButton,
    toggleRightButton
} = mapSettingsSlice.actions;

export default mapSettingsSlice.reducer;
